<template>
  <div class="mplan">
    <ul class="mleft">
      <template v-for="(item, index) in scheduleData">
        <li :class="scheduleIndex == index ? 'mf-selected' : 'mf-normal'" v-bind:key="index"
          v-on:click="dateTap(index)">{{item.date}}</li>
      </template>
    </ul>
    <el-table :data="tableData" :stripe="true" :header-cell-style="tableHeaderCellStyle">
      <el-table-column prop="courseName" label="课程" align="center" show-overflow-tooltip width="140"></el-table-column>
      <el-table-column prop="chapterName" label="章节" align="center" show-overflow-tooltip width="140"></el-table-column>
      <el-table-column prop="classesName" label="课时" align="center" show-overflow-tooltip width="140"></el-table-column>
      <el-table-column prop="classesType" label="授课类型" align="center">
        <template slot-scope="scope">
          <span style="color: #3d6fd8" v-show="scope.row.classesType == 0">录播</span>
          <span style="color: #9c2883" v-show="scope.row.classesType == 1">直播</span>
          <span style="color: #5dd02c" v-show="scope.row.classesType == 2">线下</span>
          <span style="color: #ceb32b" v-show="scope.row.classesType == 3">直播回放</span>
        </template>
      </el-table-column>
      <el-table-column prop="classStartTime" label="开始时间" align="center"></el-table-column>
      <el-table-column prop="classEndTime" label="结束时间" align="center"></el-table-column>
      <el-table-column prop="firstTeachName" label="授课教师" align="center"></el-table-column>
      <el-table-column prop="secondTeachName" label="备选教师" align="center"></el-table-column>
      <el-table-column align="center" label="操作" width="85">
        <template slot-scope="scope">
          <el-button v-show="scope.row.classesType != 2" type="text" v-on:click="studyTap(scope.$index, scope.row)">进入学习
          </el-button>
          <!--evaluateFlag是否评价,true评价过的   studyState是否学习完成,true已完成学习-->
          <!-- <el-button v-show="!scope.row.evaluateFlag && scope.row.studyState" type="text"
            v-on:click="commentTap(scope.$index, scope.row)">课时评价</el-button> -->
          <el-button type="text" @click="downLoadFile(scope.$index, scope.row)">资料下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="对当前课程进行评论" :visible="dialogVisible">
      <div class="frc">
        <span class="txt-a">课时评价</span>
        <m-star @getScore="getScoreA"></m-star>
      </div>
      <div class="frc" style="margin: 10px 0px;">
        <span class="txt-a">教师评价</span>
        <m-star @getScore="getScoreB"></m-star>
      </div>
      <p style="margin: 0px 0px 10px 0px">{{questionContent}}</p>
      <el-input type="textarea" v-model="formInfoComment.answerContent"></el-input>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import CommonStyle from "@/utils/CommonStyle";
  import MStar from "@/components/MStar";
  export default {
    name: "StudentSchedule",
    components: { MStar },
    data () {
      return {
        tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
        scheduleData: [],
        scheduleIndex: 0,
        tableData: [],
        dialogVisible: false,
        questionContent: "",
        formInfoComment: {},
        classId: 0,
      };
    },
    mounted () {
      this.queryData();
    },
    methods: {
      queryData () {
        let that = this;
        that.HttpConnection.get("/learn/usercourse/student/schedule").then(function (response) {
          that.scheduleData = response.data;
          that.tableData = response.data[0].courseList;
          that.classId = response.data[0].classId;
        })
      },
      dateTap (index) {
        this.scheduleIndex = index;
        this.tableData = this.scheduleData[index].courseList;
        this.classId = this.scheduleData[index].classId;
      },
      studyTap (index, row) {
        let that = this;
        let _classInfo = {
          teacherId: row.teacherId,
          teacherName: row.teacherName,
          classId: this.classId,
          classesId: row.classesId,
          classesName: row.classesName,
          classesType: row.classesType,
          videoName: row.videoName,
          videoUrl: row.videoUrl,
          materialsName: row.materialsName,
          materialsUrl: row.materialsUrl,
          scheduleId: row.scheduleId
        };
        sessionStorage.setItem("classInfo", JSON.stringify(_classInfo));
        this.$store.commit("clearLiveMessage");
        // let _routeUrl = this.$router.resolve({ path: "/RoomEnter" });
        // window.open(_routeUrl.href, "_blank");]
        this.$router.push({ path: "/RoomEnter" });
      },
      getScoreA (score) {
        this.formInfoComment.courseEvaluatePoint = score;
      },
      getScoreB (score) {
        this.formInfoComment.teacherEvaluatePoint = score;
      },
      commentTap (index, row) {
        this.dialogVisible = true;
        this.questionContent = row.questionContent;
        this.formInfoComment = {
          courseId: row.courseId,
          chapterId: row.chapterId,
          classesId: row.classesId,
          questionId: row.questionId,
          answerContent: "",
          teacherId: row.teacherId,
          courseEvaluatePoint: 0,
          teacherEvaluatePoint: 0
        }
      },
      submitForm () {
        let that = this;
        if (this.formInfoComment.courseEvaluatePoint == 0) {
          that.$message.error("您还未对课时进行评分");
        } else if (this.formInfoComment.teacherEvaluatePoint == 0) {
          that.$message.error("您还未对教师进行评分");
        } else if (this.formInfoComment.answerContent == "") {
          that.$message.error("请完善问题的回答");
        } else {
          that.HttpConnection.post("/evaluate/save", that.formInfoComment).then(function (response) {
            that.queryData();
            that.dialogVisible = false;
            that.$message.success("提交成功");
          });
        }
      },
      downLoadFile (index, row) {
        let that = this;
        if (row.materialsUrl) {
          let a = document.createElement("a");
          a.href = process.env.VUE_APP_imagePath + row.materialsUrl;
          document.body.appendChild(a);
          a.click(); // 下载
          URL.revokeObjectURL(a.href); // 释放URL 对象
          document.body.removeChild(a); // 删除 a 标签
        } else {
          that.$message.error("当前无下载资料");
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .mplan {
    display: flex;
    flex-direction: row;
  }

  .mleft {
    width: 120px;
    background-color: #f4f8fb;
    margin: 0px 10px 0px 0px;

    .mf-normal {
      text-align: center;
      user-select: none;
      cursor: pointer;
      margin: 10px 0px;
    }

    .mf-normal:hover {
      color: #6791d7;
    }

    .mf-selected {
      text-align: center;
      user-select: none;
      cursor: pointer;
      margin: 10px 0px;
      color: #6791d7;
    }
  }

  .txt-a {
    margin: 0px 10px 0px 0px;
  }

  /deep/.el-button+.el-button {
    margin-left: 0px;
  }
</style>